var module = angular.module('octopusApp.tenants');

module.directive('tenantStatusPopover', function () {
    return {
        restrict: 'E',
        replace: true,
        transclude: false,
        scope: {
            tenant: '=',
            projectsById: '=',
            environmentsById: '='
        },
        templateUrl: 'areas/tenants/views/tenant_status_popover.html',
        link: function ($scope) {
            $scope.getIconStyle = function () {
                var isMissingVariable = $scope.tenant.isMissingVariable();
                if (isMissingVariable == null) {
                    return 'fa-spinner fa-pulse';
                }
                return isMissingVariable ? 'fa-warning text-warning' : 'fa-info-circle';
            };
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./app/areas/tenants/directives/tenant_status_popover.js
// module id = 632
// module chunks = 1